<template>
    <el-select clearable v-model="data" placeholder="请选择" @change="handleChange">
        <el-option :label="item.supplierName" :value="item.supplierName" v-for="(item,index) in supplierNameList" :key="index"></el-option>
                    <!-- <el-option label="温州移动" value="温州移动"></el-option>
                    <el-option label="中点物联" value="中点物联"></el-option>
                    <el-option label="量讯" value="量讯"></el-option>
                    <el-option label="旭宇" value="旭宇"></el-option>
                    <el-option label="红豆电信" value="红豆电信"></el-option>
                    <el-option label="硕软" value="硕软"></el-option>
                    <el-option label="利维能" value="利维能"></el-option> -->
        </el-select>
</template>
<script>
import { findSupplierNameList } from "@/services/batch";
export default {
    name:"supplierSelect",
    data(){
        return{
            data:"",
            supplierNameList:[]
        }
    },
    props:["value"],
    watch:{
        value:{
            immediate: true,
            handler(value) {
                if (!value) {
                    this.data="";
                    this.$emit("input",value)
                } else{
                     this.data=value;
                }
            }
        }
    },
    methods:{
        handleChange(value){
            this.$emit("input",value)
            this.data=value;
      },

      async getSupplierNameList(){

       const res =await  findSupplierNameList()
       if(res&&res.code==0){
        this.supplierNameList=res.data

       }
        
      }
    },
    created(){
        this.getSupplierNameList()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/supplierSelect/index.vue